import { useState } from 'react';
import { get } from 'lodash';
import { createBipickingTabs } from '../utils/bipickingUtils';

export const useAuditState = (selectedOrder) => {
    const [activeTab, setActiveTab] = useState('primary');

    const isBipickingGroup = get(selectedOrder, 'type') === 'bipicking-group';
    const primaryOrder = get(selectedOrder, 'primaryOrder');
    const secondaryOrder = get(selectedOrder, 'secondaryOrder');
    const orderId = isBipickingGroup ? get(primaryOrder, 'id') : get(selectedOrder, 'id');
    const bipickingTabs = createBipickingTabs(primaryOrder, secondaryOrder);

    return {
        activeTab,
        setActiveTab,
        isBipickingGroup,
        primaryOrder,
        secondaryOrder,
        orderId,
        bipickingTabs
    };
};